import React from "react";
import TopicLocationPage from "@/components/TopicLocationPage";
import { trainingTopics, trainingLocations } from "@/data/topicLocationData";

export default function IOSHLeeds() {
  return <TopicLocationPage
    topic={trainingTopics.iosh}
    location={trainingLocations.leeds}
    seo={{
      title: "IOSH Training in Leeds | Livius Training",
      description: "IOSH Managing Safely for Leeds managers and supervisors. 3-day accredited course for financial, retail and logistics sector leaders. Comply with HSWA 1974. On-site across West Yorkshire or 30 mins from Leeds.",
      canonical: "https://livius-training.co.uk/IOSHLeeds"
    }}
  />;
}